import { CalendarFilled, ClockCircleFilled } from '@ant-design/icons';

import BannerWithImage from 'components/BannerWithImage';
import { I18nt } from 'utils';
import { useAgendarCita } from '../AgendarCitaContext';

import styles from './AgendarCita.module.less';

const SelectCita = () => {

  const { setCitaType } = useAgendarCita();

  return (
    <section className={styles.consultaMedicamentos}>
      <BannerWithImage className={styles.background}>
        <div className={styles.wrapper}>
          <div className={styles.pageHeader}>
            <h4 className={styles.centerDesktop}>{I18nt('elige_tipo_de_cita')}</h4>
            <p className={styles.centerDesktop}>{I18nt('elige_si_deseas_cita')}</p>
          </div>
          <div className={styles.citasMenu}>
            <div onClick={() => { setCitaType('general'); }} className={styles.citasOptionHeader}>
              <div className={styles.iconBox}>
                <CalendarFilled />
              </div>
              <h4>{I18nt('cita_medicina_general')}</h4>
            </div>
            <div onClick={() => { setCitaType('especialista'); }} className={styles.citasOptionHeader}>
              <div className={styles.iconBox}>
                <ClockCircleFilled />
              </div>
              <h4>{I18nt('cita_especialista')}</h4>
            </div>
          </div>
        </div>
      </BannerWithImage>
    </section>
  );
};

export default SelectCita;